import { Reveal, Overline } from "@/components/Reveal";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQS } from "@/data";

export default function FAQ() {
  return (
    <section id="faq" data-testid="faq-section" className="bg-[var(--alt)] py-24 md:py-36">
      <div className="section-pad grid lg:grid-cols-12 gap-12 lg:gap-20">
        <div className="lg:col-span-4">
          <Overline>Frequently Asked</Overline>
          <Reveal>
            <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[1.05] mt-6">
              Questions, answered with care.
            </h2>
          </Reveal>
        </div>

        <div className="lg:col-span-8">
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-b border-[rgba(200,149,54,0.35)]">
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="font-serif-display text-xl md:text-2xl text-left hover:no-underline py-6 hover:text-[var(--gold)] transition-colors"
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="font-sans-ui text-[var(--muted-ink)] text-base leading-relaxed font-light pb-6 max-w-2xl">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
